import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

export const InputSign = (props: { messageId: string; count?: number; glyph?: string; offsetForLabel?: boolean }) => {
    return (
        <>
            <span
                className={classNames('form-control-feedback rioglyph', props.glyph ?? 'rioglyph-exclamation-sign')}
                style={props.offsetForLabel ? { top: '27px' } : undefined}
            />
            <span className="help-block">
                <FormattedMessage id={props.messageId} values={{ count: props.count }} />
            </span>
        </>
    );
};
